// SortableLanguage.tsx

import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { CountryOption } from '@makyoapp/makyo-ui'

import { SortableItemLanguage } from '@/components/SortableItemLanguage'

function SortableLanguage({
  language,
  index,
  isDefault,
  onMakeDefault,
  onDelete,
}: {
  language: any
  index: number
  isDefault: boolean
  onMakeDefault: () => void
  onDelete: () => void
}) {
  const { t } = useTranslation()
  const [isEditing, setIsEditing] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (isEditing) {
      inputRef.current?.focus()
    }
  }, [isEditing])

  return (
    <SortableItemLanguage
      id={language.ids.locale}
      title={<CountryOption slug={language.countryCode} name={language.name} />}
      isDefault={isDefault}
      onDelete={onDelete}
      onMakeDefault={onMakeDefault}
      reorderTitle={t('Reorder Language')}
      className='w-full'
    />
  )
}

export default SortableLanguage
